/**
 * Features for product type child portfolio.
 */
export enum LicenseChildPortfolioFeatureEnum {
  ACCESS_PORTFOLIO = 'access_portfolio',
  EXTRA_MATERIALS = 'extra_materials',
}
